import {debouncer} from '../utility/utils';
import Dom from '../utility/dom';
import Modal from './accessibility';
import {smoother} from "../utility/gsap";

export const initializeNav = (event) => {
  // Menu Toggle
  const nav = document.querySelector('.main-navigation');
  nav.isOpen = false;
  const menu_toggle = nav.querySelector('.menu-toggle');

  menu_toggle.addEventListener('click', function(e){
    if(!nav.isOpen){
      menuOpen();
    }
    else {
      menuClose();
    }
  });

  const menuClose = () => {
    nav.isOpen = false;
    // Set closing class for css animation help
    nav.classList.add('closing');
    const navItems = nav.querySelectorAll('li');
    navItems.forEach(item => {
      item.classList.add('closing');
    });
    setTimeout(()=>{
      nav.classList.remove('closing');
      navItems.forEach(item=>{
        item.classList.remove('closing');
      })
    }, 700);
    
    // Set Active Class
    nav.classList.remove('toggled');
    menu_toggle.classList.remove('active');
    menu_toggle.blur();
    Dom.body.classList.remove('scroll-lock');
    if(smoother){
      smoother.paused(false);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute('aria-expanded', 'false');

    // Handle focus trapping
    Modal.close(nav);
    menu_toggle.setAttribute('tabindex', '1');
  }

  const menuOpen = () => {
    nav.isOpen = true;

    // Set Active Class
    nav.classList.add('toggled');
    menu_toggle.classList.add('active');
    menu_toggle.blur();
    Dom.body.classList.add('scroll-lock');
    if(smoother){
      smoother.paused(true);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute('aria-expanded', 'true');

    // Handle focus trapping
    Modal.open(nav);

    // Call window resize to update css custom properties for window width
    window.dispatchEvent(new Event('resize'));
  }

  // Set menu state on load and resize if changing from mobile to desktop.
  function set_menu_state(){
    // Since we don't know the menu breakpoint, check if the menu toggle is visible
    const is_desktop = menu_toggle.offsetParent === null ? true : false;

    // Desktop
    if(is_desktop){
      if(!nav.classList.contains('is_desktop')){
        nav.classList.add('is_desktop');
        nav.classList.remove('is_mobile');
      }

      // if mobile state classes are present, remove them.
      if(nav.classList.contains('toggled')){
        menuClose();
        Modal.setToFocusable(nav);
      }

      // set aria-hidden if not already set to false
      if(menu_toggle.getAttribute('aria-expanded') !== 'true'){
        menu_toggle.setAttribute('aria-expanded', 'true');
      }
    }
    // Mobile
    else {
      if(!nav.classList.contains('is_mobile')){
        nav.classList.remove('is_desktop');
        nav.classList.add('is_mobile');
      }
      
      // set aria-hidden if not already set to true and if menu isn't currently active
      if(!nav.classList.contains('toggled') && menu_toggle.getAttribute('aria-expanded') !== 'false'){
        menu_toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
  set_menu_state();

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_menu_state();
  }, 15));
};
